import { render, staticRenderFns } from "./WebsiteInfoComponent.vue?vue&type=template&id=f28e22be&scoped=true"
import script from "./WebsiteInfoComponent.vue?vue&type=script&lang=js"
export * from "./WebsiteInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./WebsiteInfoComponent.vue?vue&type=style&index=0&id=f28e22be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e22be",
  null
  
)

export default component.exports